import PropTypes from 'prop-types';

const Mixin = {
  propTypes: {
    duration_humanized: PropTypes.string.isRequired,
    min_people: PropTypes.number.isRequired,
    max_people: PropTypes.number.isRequired,
    cancellation_policy: PropTypes.object.isRequired,
    has_cancellation: PropTypes.bool.isRequired,
    available_languages: PropTypes.object.isRequired,
  },

  _defaultIconClasses() {
    return {
      duration: 'af-duration',
      people: 'af-people',
      transportation: 'af-transportation',
      availability: 'af-calendar',
      languages: 'af-chat',
    };
  },
};

export default Mixin;
